/**
 * HintsList — bulleted list of LLM-generated, question-specific guidance:
 * what's wrong/missing in THIS attempt and the next step to take. The default
 * label is "Next Step for This Question" to make its scope explicit and
 * distinguish it from the general "Practice Going Forward" suggestions and
 * from the per-attempt "Hints used"/"Hints Shown" sections (the hints the
 * student actually requested during the attempt). Stateless atom.
 */
import { LatexText } from '../../latex';

interface Props {
    items: readonly string[] | undefined;
    title?: string;
    /** Cap on how many are shown. A list of next steps is not a next step —
     *  one is the norm and two is the ceiling, so the student-facing view
     *  passes 2 and trusts the model's ordering for which two. Uncapped by
     *  default: admin/teacher review sees everything the model produced. */
    max?: number;
}

export function HintsList({ items, title = 'Next step for this question', max }: Props) {
    if (!items || items.length === 0) return null;
    const shown = max === undefined ? items : items.slice(0, max);
    return (
        <section className="sol-section sol-hints">
            <h3 className="sol-section-title">{title}</h3>
            <ul className="sol-hints-list">
                {shown.map((h, i) => (
                    <li key={i}><LatexText text={h} /></li>
                ))}
            </ul>
        </section>
    );
}
